import React, { memo } from "react";

interface SVGFilesProps {
  name: 
    'dashboadIcon' | 
    'userList' | 
    'paymentList' | 
    'orderList' | 
    'sheetInformation' | 
    'settings' | 
    'packageDetails' | 
    'sheetWeight' | 
    'changePassword' | 
    'jobRequest' | 
    'adminSidebarLogout' | 
    'rightTickIcon' | 
    'personIcon' | 
    'lockIcon' | 
    'emailIcon' | 
    'planIcon' | 
    'leganQualityIcon' | 
    'digitalPrintingIcon' | 
    'onTimeDeliveryIcon' | 
    'customToolTipIcon' | 
    'phoneIcon' | 
    'locationIcon' | 
    'myprofileIcon' | 
    'logoutIcon' | 
    'myOrdersIcon' | 
    'profileStatusIcon' | 
    'navbarMenuIcon' | 
    'invalidProfileIcon' | 
    'notificationListIcon' | 
    'bellIcon' | 
    'transhIcon' | 
    'orderStatusIcon' | 
    'activityHistoryDownIcon' | 
    'searchIcon' | 
    'singleDownloadIcon' | 
    'invalidPriceIcon' | 
    'moreIcon';
}

const SVGFiles: React.FC<SVGFilesProps> = ({ name }) => {
  const svgIcons: { [key: string]:React.ReactElement } = {
    // =================SIDEBAR OF ADMIN PANEL=====================

    dashboadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 84 78.422"
      >
        <g id="business-report" transform="translate(0 -17)" opacity="1">
          <path
            id="Path_21172"
            data-name="Path 21172"
            d="M76.617,17H7.383A7.391,7.391,0,0,0,0,24.383V72.289a7.391,7.391,0,0,0,7.383,7.383H31.22L29.415,90.5H26.25a2.461,2.461,0,0,0,0,4.922h31.5a2.461,2.461,0,0,0,0-4.922H54.585l-1.8-10.828H76.617A7.391,7.391,0,0,0,84,72.289V24.383A7.391,7.391,0,0,0,76.617,17ZM49.595,90.5H34.405l1.8-10.828H47.79ZM79.078,72.289a2.464,2.464,0,0,1-2.461,2.461H7.383a2.464,2.464,0,0,1-2.461-2.461V24.383a2.464,2.464,0,0,1,2.461-2.461H39.539v2.789a2.461,2.461,0,1,0,4.922,0V21.922H76.617a2.464,2.464,0,0,1,2.461,2.461Z"
            transform="translate(0 0)"
          />
          <path
            id="Path_21173"
            data-name="Path 21173"
            d="M88.461,128.75A2.461,2.461,0,0,0,86,131.211v8.039H80.422V123.336a2.461,2.461,0,0,0-4.922,0V139.25H69.922V115.461a2.461,2.461,0,0,0-4.922,0v26.25a2.461,2.461,0,0,0,2.461,2.461h21a2.461,2.461,0,0,0,2.461-2.461v-10.5A2.461,2.461,0,0,0,88.461,128.75Z"
            transform="translate(-54.336 -80.25)"
          />
          <path
            id="Path_21174"
            data-name="Path 21174"
            d="M287.273,121a14.266,14.266,0,0,0-10.2,24.244,1.627,1.627,0,0,0,.232.231A14.27,14.27,0,1,0,287.273,121Zm9.021,11.813h-6.56v-6.56A9.385,9.385,0,0,1,296.294,132.813Zm-11.482-6.56v8l-5.655,5.655A9.355,9.355,0,0,1,284.812,126.253Zm-2.175,17.137,5.655-5.655h8A9.355,9.355,0,0,1,282.637,143.39Z"
            transform="translate(-228.211 -86.937)"
          />
        </g>
      </svg>
    ),

    userList: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 84 84"
      >
        <g id="user" opacity="1">
          <g id="Group_17903" data-name="Group 17903" transform="translate(0)">
            <path
              id="Path_21160"
              data-name="Path 21160"
              d="M71.7,54.3a41.839,41.839,0,0,0-15.96-10.011,24.281,24.281,0,1,0-27.477,0A42.066,42.066,0,0,0,0,84H6.562a35.438,35.438,0,0,1,70.875,0H84A41.726,41.726,0,0,0,71.7,54.3ZM42,42A17.719,17.719,0,1,1,59.719,24.281,17.739,17.739,0,0,1,42,42Z"
              transform="translate(0)"
            />
          </g>
        </g>
      </svg>
    ),
    paymentList: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 84 84"
      >
        <g
          id="hand_2_"
          data-name="hand (2)"
          transform="translate(-0.501)"
          opacity="1"
        >
          <path
            id="Path_21161"
            data-name="Path 21161"
            d="M221.51,332.98a1.633,1.633,0,1,0-2.308,0A1.634,1.634,0,0,0,221.51,332.98Zm0,0"
            transform="translate(-182.402 -276.01)"
          />
          <path
            id="Path_21162"
            data-name="Path 21162"
            d="M188.449,17.948A17.948,17.948,0,1,0,206.4,0,17.968,17.968,0,0,0,188.449,17.948Zm32.632,0A14.685,14.685,0,1,1,206.4,3.264,14.7,14.7,0,0,1,221.081,17.948Zm0,0"
            transform="translate(-156.974)"
          />
          <path
            id="Path_21163"
            data-name="Path 21163"
            d="M19.4,260.746a1.647,1.647,0,0,0,2.316.013l7.954-7.793a4.911,4.911,0,0,0,1.168-5.063l1.711-1.641a4.908,4.908,0,0,1,3.416-1.373H57.775a14.732,14.732,0,0,0,10.3-4.161c.114-.11-.866,1.038,14.88-17.677a6.51,6.51,0,0,0-.78-9.2,6.6,6.6,0,0,0-9.207.728l-9.681,9.9a6.608,6.608,0,0,0-5.1-2.429H39.89a21.269,21.269,0,0,0-8.216-1.631c-7.9,0-14.8,3.629-18.5,10.432A4.918,4.918,0,0,0,8.785,232.2L.98,239.985a1.625,1.625,0,0,0,0,2.3Zm12.275-37.067a18,18,0,0,1,7.223,1.495,1.645,1.645,0,0,0,.658.137H58.186a3.263,3.263,0,1,1,0,6.526H44.8a1.631,1.631,0,1,0,0,3.263H58.186a6.514,6.514,0,0,0,6.5-7.379c9.365-9.574,10.686-10.919,10.742-10.986a3.305,3.305,0,0,1,4.626-.389,3.257,3.257,0,0,1,.385,4.605L65.728,238.446a11.458,11.458,0,0,1-7.952,3.181H35.964a8.181,8.181,0,0,0-5.7,2.287l-1.394,1.338L16.021,232.47c3-5.6,8.641-8.792,15.652-8.792ZM11.107,234.506a1.644,1.644,0,0,1,2.032-.23c.284.172-.531-.566,14.211,14.074a1.628,1.628,0,0,1,.009,2.3l-6.781,6.644L4.456,241.139Zm0,0"
            transform="translate(0 -177.228)"
          />
          <path
            id="Path_21164"
            data-name="Path 21164"
            d="M269.155,41.62v1.912a4.894,4.894,0,0,0,1.631,9.509,1.631,1.631,0,0,1,0,3.263,2.951,2.951,0,0,1-2.119-1.234,1.632,1.632,0,0,0-2.5,2.1,6.769,6.769,0,0,0,2.985,2.125v1.9a1.631,1.631,0,1,0,3.263,0V59.287a4.894,4.894,0,0,0-1.631-9.509,1.632,1.632,0,0,1,0-3.263,2.62,2.62,0,0,1,1.765.853,1.632,1.632,0,0,0,2.269-2.345,6.3,6.3,0,0,0-2.4-1.5v-1.9a1.631,1.631,0,1,0-3.263,0Zm0,0"
            transform="translate(-221.716 -33.462)"
          />
        </g>
      </svg>
    ),

    orderList: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 67.196 84"
      >
        <g
          id="clipboard_1_"
          data-name="clipboard (1)"
          transform="translate(-47.037)"
          opacity="1"
        >
          <g
            id="Group_17905"
            data-name="Group 17905"
            transform="translate(47.037 0)"
          >
            <g
              id="Group_17904"
              data-name="Group 17904"
              transform="translate(0 0)"
            >
              <path
                id="Path_21165"
                data-name="Path 21165"
                d="M105.681,11.006H97.943v-3.4c0-1.1-1.222-1.6-2.342-1.6H89.595c-1.425-4-4.989-6-9.061-6a9.265,9.265,0,0,0-9.061,6H65.567c-1.12,0-2.24.5-2.24,1.6v3.4H55.589a8.585,8.585,0,0,0-8.552,8.1V76.4c0,4.4,4.072,7.6,8.552,7.6h50.091c4.48,0,8.552-3.2,8.552-7.6v-57.3A8.585,8.585,0,0,0,105.681,11.006Zm-38.281-1H73a2.223,2.223,0,0,0,1.935-1.8,5.88,5.88,0,0,1,5.6-4.5,5.776,5.776,0,0,1,5.5,4.5,2.226,2.226,0,0,0,2.036,1.8h5.8v8H67.4ZM110.16,76.4c0,2.2-2.24,3.6-4.48,3.6H55.589c-2.24,0-4.48-1.4-4.48-3.6v-57.3a4.548,4.548,0,0,1,4.48-4.1h7.738v5.1a2.126,2.126,0,0,0,2.24,1.9H95.6a2.229,2.229,0,0,0,2.342-1.9v-5.1h7.738a4.549,4.549,0,0,1,4.48,4.1V76.4Z"
                transform="translate(-47.037 0)"
              />
              <path
                id="Path_21166"
                data-name="Path 21166"
                d="M114.661,230.935a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,231.01,114.7,230.972,114.661,230.935Z"
                transform="translate(-89.122 -186.232)"
              />
              <path
                id="Path_21167"
                data-name="Path 21167"
                d="M223.546,256.034h-23a2,2,0,1,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -207.031)"
              />
              <path
                id="Path_21168"
                data-name="Path 21168"
                d="M114.661,147.343a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,147.418,114.7,147.38,114.661,147.343Z"
                transform="translate(-89.122 -118.639)"
              />
              <path
                id="Path_21169"
                data-name="Path 21169"
                d="M223.546,172.442h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -139.438)"
              />
              <path
                id="Path_21170"
                data-name="Path 21170"
                d="M114.661,314.526a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,314.6,114.7,314.563,114.661,314.526Z"
                transform="translate(-89.122 -253.824)"
              />
              <path
                id="Path_21171"
                data-name="Path 21171"
                d="M223.546,339.626h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -274.625)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),

    sheetInformation: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 67.196 84"
      >
        <g
          id="clipboard_1_"
          data-name="clipboard (1)"
          transform="translate(-47.037)"
          opacity="1"
        >
          <g
            id="Group_17905"
            data-name="Group 17905"
            transform="translate(47.037 0)"
          >
            <g
              id="Group_17904"
              data-name="Group 17904"
              transform="translate(0 0)"
            >
              <path
                id="Path_21165"
                data-name="Path 21165"
                d="M105.681,11.006H97.943v-3.4c0-1.1-1.222-1.6-2.342-1.6H89.595c-1.425-4-4.989-6-9.061-6a9.265,9.265,0,0,0-9.061,6H65.567c-1.12,0-2.24.5-2.24,1.6v3.4H55.589a8.585,8.585,0,0,0-8.552,8.1V76.4c0,4.4,4.072,7.6,8.552,7.6h50.091c4.48,0,8.552-3.2,8.552-7.6v-57.3A8.585,8.585,0,0,0,105.681,11.006Zm-38.281-1H73a2.223,2.223,0,0,0,1.935-1.8,5.88,5.88,0,0,1,5.6-4.5,5.776,5.776,0,0,1,5.5,4.5,2.226,2.226,0,0,0,2.036,1.8h5.8v8H67.4ZM110.16,76.4c0,2.2-2.24,3.6-4.48,3.6H55.589c-2.24,0-4.48-1.4-4.48-3.6v-57.3a4.548,4.548,0,0,1,4.48-4.1h7.738v5.1a2.126,2.126,0,0,0,2.24,1.9H95.6a2.229,2.229,0,0,0,2.342-1.9v-5.1h7.738a4.549,4.549,0,0,1,4.48,4.1V76.4Z"
                transform="translate(-47.037 0)"
              />
              <path
                id="Path_21166"
                data-name="Path 21166"
                d="M114.661,230.935a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,231.01,114.7,230.972,114.661,230.935Z"
                transform="translate(-89.122 -186.232)"
              />
              <path
                id="Path_21167"
                data-name="Path 21167"
                d="M223.546,256.034h-23a2,2,0,1,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -207.031)"
              />
              <path
                id="Path_21168"
                data-name="Path 21168"
                d="M114.661,147.343a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,147.418,114.7,147.38,114.661,147.343Z"
                transform="translate(-89.122 -118.639)"
              />
              <path
                id="Path_21169"
                data-name="Path 21169"
                d="M223.546,172.442h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -139.438)"
              />
              <path
                id="Path_21170"
                data-name="Path 21170"
                d="M114.661,314.526a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,314.6,114.7,314.563,114.661,314.526Z"
                transform="translate(-89.122 -253.824)"
              />
              <path
                id="Path_21171"
                data-name="Path 21171"
                d="M223.546,339.626h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -274.625)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    settings: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 67.196 84"
      >
        <g
          id="clipboard_1_"
          data-name="clipboard (1)"
          transform="translate(-47.037)"
          opacity="1"
        >
          <g
            id="Group_17905"
            data-name="Group 17905"
            transform="translate(47.037 0)"
          >
            <g
              id="Group_17904"
              data-name="Group 17904"
              transform="translate(0 0)"
            >
              <path
                id="Path_21165"
                data-name="Path 21165"
                d="M105.681,11.006H97.943v-3.4c0-1.1-1.222-1.6-2.342-1.6H89.595c-1.425-4-4.989-6-9.061-6a9.265,9.265,0,0,0-9.061,6H65.567c-1.12,0-2.24.5-2.24,1.6v3.4H55.589a8.585,8.585,0,0,0-8.552,8.1V76.4c0,4.4,4.072,7.6,8.552,7.6h50.091c4.48,0,8.552-3.2,8.552-7.6v-57.3A8.585,8.585,0,0,0,105.681,11.006Zm-38.281-1H73a2.223,2.223,0,0,0,1.935-1.8,5.88,5.88,0,0,1,5.6-4.5,5.776,5.776,0,0,1,5.5,4.5,2.226,2.226,0,0,0,2.036,1.8h5.8v8H67.4ZM110.16,76.4c0,2.2-2.24,3.6-4.48,3.6H55.589c-2.24,0-4.48-1.4-4.48-3.6v-57.3a4.548,4.548,0,0,1,4.48-4.1h7.738v5.1a2.126,2.126,0,0,0,2.24,1.9H95.6a2.229,2.229,0,0,0,2.342-1.9v-5.1h7.738a4.549,4.549,0,0,1,4.48,4.1V76.4Z"
                transform="translate(-47.037 0)"
              />
              <path
                id="Path_21166"
                data-name="Path 21166"
                d="M114.661,230.935a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,231.01,114.7,230.972,114.661,230.935Z"
                transform="translate(-89.122 -186.232)"
              />
              <path
                id="Path_21167"
                data-name="Path 21167"
                d="M223.546,256.034h-23a2,2,0,1,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -207.031)"
              />
              <path
                id="Path_21168"
                data-name="Path 21168"
                d="M114.661,147.343a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,147.418,114.7,147.38,114.661,147.343Z"
                transform="translate(-89.122 -118.639)"
              />
              <path
                id="Path_21169"
                data-name="Path 21169"
                d="M223.546,172.442h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -139.438)"
              />
              <path
                id="Path_21170"
                data-name="Path 21170"
                d="M114.661,314.526a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,314.6,114.7,314.563,114.661,314.526Z"
                transform="translate(-89.122 -253.824)"
              />
              <path
                id="Path_21171"
                data-name="Path 21171"
                d="M223.546,339.626h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -274.625)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),

    packageDetails: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 67.196 84"
      >
        <g
          id="clipboard_1_"
          data-name="clipboard (1)"
          transform="translate(-47.037)"
          opacity="1"
        >
          <g
            id="Group_17905"
            data-name="Group 17905"
            transform="translate(47.037 0)"
          >
            <g
              id="Group_17904"
              data-name="Group 17904"
              transform="translate(0 0)"
            >
              <path
                id="Path_21165"
                data-name="Path 21165"
                d="M105.681,11.006H97.943v-3.4c0-1.1-1.222-1.6-2.342-1.6H89.595c-1.425-4-4.989-6-9.061-6a9.265,9.265,0,0,0-9.061,6H65.567c-1.12,0-2.24.5-2.24,1.6v3.4H55.589a8.585,8.585,0,0,0-8.552,8.1V76.4c0,4.4,4.072,7.6,8.552,7.6h50.091c4.48,0,8.552-3.2,8.552-7.6v-57.3A8.585,8.585,0,0,0,105.681,11.006Zm-38.281-1H73a2.223,2.223,0,0,0,1.935-1.8,5.88,5.88,0,0,1,5.6-4.5,5.776,5.776,0,0,1,5.5,4.5,2.226,2.226,0,0,0,2.036,1.8h5.8v8H67.4ZM110.16,76.4c0,2.2-2.24,3.6-4.48,3.6H55.589c-2.24,0-4.48-1.4-4.48-3.6v-57.3a4.548,4.548,0,0,1,4.48-4.1h7.738v5.1a2.126,2.126,0,0,0,2.24,1.9H95.6a2.229,2.229,0,0,0,2.342-1.9v-5.1h7.738a4.549,4.549,0,0,1,4.48,4.1V76.4Z"
                transform="translate(-47.037 0)"
              />
              <path
                id="Path_21166"
                data-name="Path 21166"
                d="M114.661,230.935a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,231.01,114.7,230.972,114.661,230.935Z"
                transform="translate(-89.122 -186.232)"
              />
              <path
                id="Path_21167"
                data-name="Path 21167"
                d="M223.546,256.034h-23a2,2,0,1,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -207.031)"
              />
              <path
                id="Path_21168"
                data-name="Path 21168"
                d="M114.661,147.343a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,147.418,114.7,147.38,114.661,147.343Z"
                transform="translate(-89.122 -118.639)"
              />
              <path
                id="Path_21169"
                data-name="Path 21169"
                d="M223.546,172.442h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -139.438)"
              />
              <path
                id="Path_21170"
                data-name="Path 21170"
                d="M114.661,314.526a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,314.6,114.7,314.563,114.661,314.526Z"
                transform="translate(-89.122 -253.824)"
              />
              <path
                id="Path_21171"
                data-name="Path 21171"
                d="M223.546,339.626h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -274.625)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),

    sheetWeight: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 67.196 84"
      >
        <g
          id="clipboard_1_"
          data-name="clipboard (1)"
          transform="translate(-47.037)"
          opacity="1"
        >
          <g
            id="Group_17905"
            data-name="Group 17905"
            transform="translate(47.037 0)"
          >
            <g
              id="Group_17904"
              data-name="Group 17904"
              transform="translate(0 0)"
            >
              <path
                id="Path_21165"
                data-name="Path 21165"
                d="M105.681,11.006H97.943v-3.4c0-1.1-1.222-1.6-2.342-1.6H89.595c-1.425-4-4.989-6-9.061-6a9.265,9.265,0,0,0-9.061,6H65.567c-1.12,0-2.24.5-2.24,1.6v3.4H55.589a8.585,8.585,0,0,0-8.552,8.1V76.4c0,4.4,4.072,7.6,8.552,7.6h50.091c4.48,0,8.552-3.2,8.552-7.6v-57.3A8.585,8.585,0,0,0,105.681,11.006Zm-38.281-1H73a2.223,2.223,0,0,0,1.935-1.8,5.88,5.88,0,0,1,5.6-4.5,5.776,5.776,0,0,1,5.5,4.5,2.226,2.226,0,0,0,2.036,1.8h5.8v8H67.4ZM110.16,76.4c0,2.2-2.24,3.6-4.48,3.6H55.589c-2.24,0-4.48-1.4-4.48-3.6v-57.3a4.548,4.548,0,0,1,4.48-4.1h7.738v5.1a2.126,2.126,0,0,0,2.24,1.9H95.6a2.229,2.229,0,0,0,2.342-1.9v-5.1h7.738a4.549,4.549,0,0,1,4.48,4.1V76.4Z"
                transform="translate(-47.037 0)"
              />
              <path
                id="Path_21166"
                data-name="Path 21166"
                d="M114.661,230.935a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,231.01,114.7,230.972,114.661,230.935Z"
                transform="translate(-89.122 -186.232)"
              />
              <path
                id="Path_21167"
                data-name="Path 21167"
                d="M223.546,256.034h-23a2,2,0,1,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -207.031)"
              />
              <path
                id="Path_21168"
                data-name="Path 21168"
                d="M114.661,147.343a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,147.418,114.7,147.38,114.661,147.343Z"
                transform="translate(-89.122 -118.639)"
              />
              <path
                id="Path_21169"
                data-name="Path 21169"
                d="M223.546,172.442h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -139.438)"
              />
              <path
                id="Path_21170"
                data-name="Path 21170"
                d="M114.661,314.526a2,2,0,0,0-2.8-.1l-6.4,6.1-2.7-2.8a2,2,0,0,0-2.8-.1,2.1,2.1,0,0,0,0,2.9l4.1,4.2a1.8,1.8,0,0,0,1.4.6,2,2,0,0,0,1.4-.6l7.8-7.4a1.9,1.9,0,0,0,.115-2.684C114.739,314.6,114.7,314.563,114.661,314.526Z"
                transform="translate(-89.122 -253.824)"
              />
              <path
                id="Path_21171"
                data-name="Path 21171"
                d="M223.546,339.626h-23a2,2,0,0,0,0,4h23a2,2,0,1,0,0-4Z"
                transform="translate(-168.657 -274.625)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),

    changePassword: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="30"
        height="30"
        x="0px"
        y="0px"
      >
        <g>
          <path d="M465.6249,146.9805a11.2469,11.2469,0,1,0-19.9511,10.3886A212.9154,212.9154,0,0,1,407.1425,407.207c-83.3379,83.32-218.9355,83.3379-302.291,0a11.2465,11.2465,0,0,0-19.2041,7.9541v56.9a11.25,11.25,0,0,0,22.5,0V440.3506a236.62,236.62,0,0,0,314.9033-17.2354C496.3515,349.8145,513.4638,238.8438,465.6249,146.9805Z" />
          <path d="M104.8515,104.916a213.7356,213.7356,0,0,1,302.291,0,11.2465,11.2465,0,0,0,19.2041-7.9541v-56.9a11.25,11.25,0,0,0-22.5,0V71.7549A236.3026,236.3026,0,0,0,46.3779,365.1426,11.2469,11.2469,0,0,0,66.329,354.7539,212.9,212.9,0,0,1,104.8515,104.916Z" />
          <path d="M255.997,82.8115A89.1082,89.1082,0,0,0,166.99,171.8184V216.37H153.4023a38.29,38.29,0,0,0-38.25,38.25V364.0615a38.29,38.29,0,0,0,38.25,38.25H358.6005a38.29,38.29,0,0,0,38.25-38.25V254.62a38.29,38.29,0,0,0-38.25-38.25H345.0126V171.8184A89.11,89.11,0,0,0,255.997,82.8115ZM189.49,171.8184a66.5112,66.5112,0,0,1,133.0224,0V216.37H189.49Zm184.86,82.8017V364.0615a15.7691,15.7691,0,0,1-15.75,15.75H153.4023a15.7691,15.7691,0,0,1-15.75-15.75V254.62a15.7691,15.7691,0,0,1,15.75-15.75H358.6005A15.7691,15.7691,0,0,1,374.3505,254.62Z" />
          <circle cx="327.997" cy="309.3408" r="22.5" />
          <circle cx="255.997" cy="309.3408" r="22.5" />
          <circle cx="183.997" cy="309.3408" r="22.5" />
        </g>
      </svg>
    ),

    jobRequest: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 84 84"
      >
        <g id="printer_1_" data-name="printer (1)" opacity="1">
          <path
            id="Path_3744"
            data-name="Path 3744"
            d="M71.7,21.164H69.4V12.3A12.319,12.319,0,0,0,57.094,0H26.906A12.319,12.319,0,0,0,14.6,12.3v8.859H12.3A12.319,12.319,0,0,0,0,33.469V53.156a12.319,12.319,0,0,0,12.3,12.3h2.3V76.617A7.391,7.391,0,0,0,21.984,84H62.016A7.391,7.391,0,0,0,69.4,76.617V65.461h2.3A12.319,12.319,0,0,0,84,53.156V33.469A12.319,12.319,0,0,0,71.7,21.164ZM19.523,12.3a7.391,7.391,0,0,1,7.383-7.383H57.094A7.391,7.391,0,0,1,64.477,12.3v8.859H19.523ZM64.477,76.617a2.464,2.464,0,0,1-2.461,2.461H21.984a2.464,2.464,0,0,1-2.461-2.461V52.336H64.477Zm14.6-23.461A7.391,7.391,0,0,1,71.7,60.539H69.4v-8.2h1.477a2.461,2.461,0,0,0,0-4.922H13.125a2.461,2.461,0,0,0,0,4.922H14.6v8.2H12.3a7.391,7.391,0,0,1-7.383-7.383V33.469A7.391,7.391,0,0,1,12.3,26.086H71.7a7.391,7.391,0,0,1,7.383,7.383Z"
          />
          <path
            id="Path_3745"
            data-name="Path 3745"
            d="M216.624,353H203.467a2.467,2.467,0,1,0,0,4.934h13.157a2.467,2.467,0,0,0,0-4.934Z"
            transform="translate(-168.046 -295.095)"
          />
          <path
            id="Path_3746"
            data-name="Path 3746"
            d="M216.624,417H203.467a2.467,2.467,0,1,0,0,4.934h13.157a2.467,2.467,0,0,0,0-4.934Z"
            transform="translate(-168.046 -348.624)"
          />
          <path
            id="Path_3747"
            data-name="Path 3747"
            d="M75.361,193H67.467a2.467,2.467,0,0,0,0,4.934h7.894a2.467,2.467,0,0,0,0-4.934Z"
            transform="translate(-54.31 -161.341)"
          />
        </g>
      </svg>
    ),

    adminSidebarLogout: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 84 81.802"
      >
        <path
          id="Logout"
          d="M40.1,2.021A18.141,18.141,0,0,1,58.216,19.307l.02.854v3.816a3.068,3.068,0,0,1-6.107.416l-.028-.416V20.161A12.006,12.006,0,0,0,40.8,8.177l-.705-.02H20.157a12,12,0,0,0-11.98,11.3l-.02.705V65.684a12.005,12.005,0,0,0,11.3,11.984l.7.02h19.98A11.964,11.964,0,0,0,52.081,66.431l.02-.7V61.872a3.068,3.068,0,0,1,6.107-.416l.028.416v3.857A18.1,18.1,0,0,1,41.014,83.8l-.877.021H20.157A18.14,18.14,0,0,1,2.042,66.537l-.02-.854V20.161A18.14,18.14,0,0,1,19.3,2.041l.854-.02ZM85.076,40.706a3.068,3.068,0,0,1-.018,4.448L73.142,57.022a3.068,3.068,0,0,1-4.627-4l.3-.343,6.708-6.685H33.706a3.068,3.068,0,0,1-.416-6.107l.416-.028H75.528l-6.715-6.682a3.069,3.069,0,0,1-.306-3.993l.3-.345a3.068,3.068,0,0,1,3.993-.306l.345.3Z"
          transform="translate(-2.022 -2.021)"
          fillRule="evenodd"
          opacity="1"
          fill="#fff"
        />
      </svg>
    ),

    rightTickIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="11"
        viewBox="0 0 84 59.224"
      >
        <path
          id="Path_21184"
          data-name="Path 21184"
          d="M197.993,158.424a5.1,5.1,0,0,0-7.214,0l-45.415,45.415L124.2,182.671a5.1,5.1,0,1,0-7.214,7.214l24.775,24.775a5.1,5.1,0,0,0,7.214,0l49.022-49.022A5.1,5.1,0,0,0,197.993,158.424Z"
          transform="translate(-115.487 -156.93)"
          opacity="1"
          fill="#2EBCED"
        />
      </svg>
    ),

    // ==========SIGNUP SECTION===================

    personIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 25 30"
      >
        <path
          id="Path_2"
          data-name="Path 2"
          d="M28.467,23.685l-.1.121A16.057,16.057,0,0,1,15.967,30a16.056,16.056,0,0,1-12.4-6.194l-.1-.121.024-.155a12.869,12.869,0,0,1,6.128-9.486l.235-.137.188.2a8.133,8.133,0,0,0,11.85,0l.188-.2.235.137a12.871,12.871,0,0,1,6.128,9.486Zm-12.5-8.7A7.491,7.491,0,1,0,8.525,7.491,7.475,7.475,0,0,0,15.967,14.982Z"
          transform="translate(-3.467)"
          fill="#2ebced"
        />
      </svg>
    ),

    lockIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 22 30"
      >
        <path
          id="Path_3"
          data-name="Path 3"
          d="M85.389,11.25H83.556V8.75a8.558,8.558,0,1,0-17.111,0v2.5H64.611a.618.618,0,0,0-.611.625V27.5A2.475,2.475,0,0,0,66.444,30H83.556A2.475,2.475,0,0,0,86,27.5V11.875A.618.618,0,0,0,85.389,11.25ZM76.83,24.306a.636.636,0,0,1-.152.486.605.605,0,0,1-.455.208H73.778a.605.605,0,0,1-.455-.208.635.635,0,0,1-.152-.486l.386-3.546a2.445,2.445,0,1,1,2.889,0ZM79.889,11.25H70.111V8.75a4.89,4.89,0,1,1,9.778,0Z"
          transform="translate(-64)"
          fill="#2ebced"
        />
      </svg>
    ),

    // ==================RESET PASWORD SECTION==================

    emailIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 30 27"
      >
        <path
          id="Message"
          d="M24.409,3A7.585,7.585,0,0,1,32,10.575v11.85A7.586,7.586,0,0,1,24.409,30H9.59A7.585,7.585,0,0,1,2,22.425V10.575A7.575,7.575,0,0,1,9.59,3ZM26.8,12.81l.12-.12a1.16,1.16,0,0,0-.016-1.5,1.261,1.261,0,0,0-.794-.39,1.14,1.14,0,0,0-.841.3L18.5,16.5a2.35,2.35,0,0,1-3,0L8.75,11.1a1.147,1.147,0,0,0-1.607,1.6l.2.195,6.825,5.325a4.723,4.723,0,0,0,5.863,0Z"
          transform="translate(-2 -3)"
          fill="#2ebced"
          fillRule="evenodd"
        />
      </svg>
    ),

    // ==================PLAN SECTION==================
    planIcon: (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="150"
        viewBox="0 0 44.55 33.07"
        style={{
          fill: "#ff9494",
        }}
      >
        <path
          className="cls-1"
          style={{
            fill: "#ff9494",
          }}
          d="M29.38,2.34h2.46c.65,0,1.17-.53,1.17-1.17S32.48,0,31.84,0h-2.46C28.73,0,28.21,.53,28.21,1.17s.53,1.17,1.17,1.17Z"
        />
        <g>
          <polygon
            className="cls-2"
            style={{
              fill: "none",
            }}
            points="21.18 26.26 35.84 26.26 28.51 18.32 21.18 26.26"
          />
          <path
            className="cls-2"
            style={{
              fill: "none",
            }}
            d="M16.62,11.23c-.38-.38-.88-.58-1.41-.58s-1.03,.21-1.41,.58c-.38,.38-.58,.88-.58,1.41s.21,1.04,.58,1.41c.36,.36,.87,.56,1.41,.56s1.05-.21,1.41-.56c.38-.38,.58-.88,.58-1.41s-.21-1.03-.58-1.41Z"
          />
          <polygon
            className="cls-2"
            style={{
              fill: "none",
            }}
            points="17.52 21.42 13.05 26.26 18.12 26.26 20.06 24.16 17.52 21.42"
          />
          <path
            className="cls-1"
            style={{
              fill: "#ff9494",
            }}
            d="M43.38,4.34h-3.27c-.65,0-1.17,.53-1.17,1.17s.53,1.17,1.17,1.17h2.09V30.73H6.69V6.69H29.86c.65,0,1.17-.53,1.17-1.17s-.53-1.17-1.17-1.17H5.52c-.65,0-1.17,.53-1.17,1.17V31.9c0,.65,.53,1.17,1.17,1.17H43.38c.65,0,1.17-.53,1.17-1.17V5.52c0-.65-.53-1.17-1.17-1.17Z"
          />
          <path
            className="cls-1"
            style={{
              fill: "#ff9494",
            }}
            d="M18.2,15.62c.8-.8,1.24-1.86,1.24-2.99s-.44-2.19-1.24-2.99c-.8-.8-1.86-1.24-2.99-1.24s-2.19,.44-2.99,1.24c-.8,.8-1.24,1.86-1.24,2.99s.44,2.19,1.24,2.99c.8,.8,1.86,1.24,2.99,1.24s2.19-.44,2.99-1.24Zm-1.58-1.58c-.36,.36-.87,.56-1.41,.56s-1.05-.21-1.41-.56c-.38-.38-.58-.88-.58-1.41s.21-1.03,.58-1.41c.37-.38,.87-.58,1.41-.58s1.04,.21,1.41,.58c.38,.38,.58,.88,.58,1.41s-.21,1.03-.58,1.41Z"
          />
          <path
            className="cls-1"
            style={{
              fill: "#ff9494",
            }}
            d="M9.36,27.38c0,.62,.5,1.13,1.13,1.13h27.93c.28,0,.55-.11,.76-.3,.46-.42,.49-1.13,.07-1.59l-9.9-10.72-.06-.06c-.21-.19-.48-.3-.76-.3-.02,0-.04,0-.05,0-.3,.01-.58,.14-.78,.36l-6.1,6.6-3.3-3.57c-.22-.21-.51-.31-.81-.3-.3,.01-.58,.14-.78,.36l-6.99,7.57c-.22,.21-.35,.5-.35,.81Zm3.7-1.12l4.47-4.84,2.53,2.74-1.93,2.09h-5.07Zm8.13,0l7.33-7.93,7.33,7.93h-14.66Z"
          />
          <path
            className="cls-1"
            style={{
              fill: "#ff9494",
            }}
            d="M33.73,6.69h2.46c.65,0,1.17-.53,1.17-1.17s-.53-1.17-1.17-1.17h-2.46c-.65,0-1.17,.53-1.17,1.17s.53,1.17,1.17,1.17Z"
          />
        </g>
        <path
          className="cls-1"
          style={{
            fill: "#ff9494",
          }}
          d="M25.52,0H1.17C.53,0,0,.53,0,1.17V27.56c0,.65,.53,1.17,1.17,1.17,.65,0,1.17-.53,1.17-1.17V2.34H25.52c.65,0,1.17-.53,1.17-1.17s-.53-1.17-1.17-1.17Z"
        />
        <path
          className="cls-1"
          style={{
            fill: "#ff9494",
          }}
          d="M39.04,2.34c.64,0,1.17-.53,1.17-1.17,0-.65-.53-1.17-1.17-1.17h-3.27c-.65,0-1.17,.53-1.17,1.17s.53,1.17,1.17,1.17h3.27Z"
        />
      </svg>
    ),

    // ==================HOME SECTION==================
    leganQualityIcon: (
      <svg
        className="mb-3"
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 84 84"
      >
        <g id="checked" transform="translate(-2.083 -0.001)">
          <path
            id="Path_5"
            data-name="Path 5"
            d="M122.215,92.952a1.227,1.227,0,1,0-.278,2.439,24.7,24.7,0,1,1-5.625,0,1.228,1.228,0,1,0-.281-2.439,27.19,27.19,0,1,0,6.184,0Z"
            transform="translate(-75.057 -77.623)"
            fill="#ff9494"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M112.836,92.936a5.159,5.159,0,0,1,1.448-5.349,7.578,7.578,0,0,0,0-11.227,5.158,5.158,0,0,1-1.448-5.349,7.582,7.582,0,0,0-.681-6.093,7.721,7.721,0,0,0-4.989-3.63,5.219,5.219,0,0,1-3.955-3.916,7.656,7.656,0,0,0-3.667-4.94,7.794,7.794,0,0,0-6.154-.674,5.28,5.28,0,0,1-5.4-1.433,7.758,7.758,0,0,0-11.34,0,5.28,5.28,0,0,1-5.4,1.433,7.8,7.8,0,0,0-6.154.674,7.655,7.655,0,0,0-3.667,4.94,5.219,5.219,0,0,1-3.955,3.916,7.721,7.721,0,0,0-4.989,3.63,7.582,7.582,0,0,0-.681,6.093,5.159,5.159,0,0,1-1.448,5.349,7.578,7.578,0,0,0,0,11.227A5.158,5.158,0,0,1,51.8,92.936a7.582,7.582,0,0,0,.681,6.093,7.72,7.72,0,0,0,4.989,3.63,5.219,5.219,0,0,1,3.955,3.916,7.656,7.656,0,0,0,3.667,4.94,7.8,7.8,0,0,0,6.154.674,5.28,5.28,0,0,1,5.4,1.433,7.758,7.758,0,0,0,11.34,0,5.28,5.28,0,0,1,5.4-1.433,7.8,7.8,0,0,0,6.154-.674,7.655,7.655,0,0,0,3.667-4.94,5.219,5.219,0,0,1,3.955-3.916,7.721,7.721,0,0,0,4.989-3.63A7.582,7.582,0,0,0,112.836,92.936Zm-2.37.734A5.071,5.071,0,0,1,110,97.8a5.164,5.164,0,0,1-3.382,2.46,7.7,7.7,0,0,0-5.835,5.777,5.12,5.12,0,0,1-2.485,3.348,5.214,5.214,0,0,1-4.171.457,7.789,7.789,0,0,0-7.971,2.115,5.258,5.258,0,0,1-7.686,0,7.788,7.788,0,0,0-7.971-2.115,5.215,5.215,0,0,1-4.171-.457,5.12,5.12,0,0,1-2.485-3.348,7.7,7.7,0,0,0-5.835-5.777,5.164,5.164,0,0,1-3.382-2.46,5.071,5.071,0,0,1-.461-4.13,7.61,7.61,0,0,0-2.136-7.892,5.136,5.136,0,0,1,0-7.609,7.611,7.611,0,0,0,2.136-7.892,5.071,5.071,0,0,1,.461-4.13,5.164,5.164,0,0,1,3.382-2.46,7.7,7.7,0,0,0,5.835-5.777,5.12,5.12,0,0,1,2.485-3.348,5.212,5.212,0,0,1,4.171-.457,7.791,7.791,0,0,0,7.971-2.115,5.258,5.258,0,0,1,7.686,0,7.791,7.791,0,0,0,7.971,2.115,5.212,5.212,0,0,1,4.171.457,5.12,5.12,0,0,1,2.485,3.348,7.7,7.7,0,0,0,5.835,5.777A5.164,5.164,0,0,1,110,66.148a5.071,5.071,0,0,1,.461,4.13,7.61,7.61,0,0,0,2.136,7.892,5.136,5.136,0,0,1,0,7.609,7.61,7.61,0,0,0-2.136,7.892Z"
            transform="translate(-38.234 -39.973)"
            fill="#ff9494"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M433.424,12.816a1.232,1.232,0,0,0,.874-.362l10.34-10.34A1.236,1.236,0,0,0,442.89.365l-10.34,10.34a1.236,1.236,0,0,0,.874,2.11Z"
            transform="translate(-358.917 -0.002)"
            fill="#ff9494"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M471.151,100.388a1.236,1.236,0,0,0-1.518-.867l-5.17,1.41a1.236,1.236,0,1,0,.651,2.385l5.17-1.41A1.236,1.236,0,0,0,471.151,100.388Z"
            transform="translate(-385.111 -83.159)"
            fill="#ff9494"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M387.127,7.6a1.235,1.235,0,0,0,1.518-.867l1.41-5.17a1.236,1.236,0,1,0-2.385-.651l-1.411,5.17A1.236,1.236,0,0,0,387.127,7.6Z"
            transform="translate(-320.584 0)"
            fill="#ff9494"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M12.789,12.454a1.236,1.236,0,1,0,1.748-1.748L4.2.365A1.236,1.236,0,0,0,2.448,2.114Z"
            transform="translate(-0.002 -0.002)"
            fill="#ff9494"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M8.817,100.931l-5.17-1.41A1.236,1.236,0,1,0,3,101.905l5.17,1.41a1.236,1.236,0,1,0,.651-2.385Z"
            transform="translate(-0.001 -83.159)"
            fill="#ff9494"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M103.685,6.733a1.236,1.236,0,0,0,2.385-.651l-1.41-5.17a1.236,1.236,0,1,0-2.385.651Z"
            transform="translate(-83.579 0)"
            fill="#ff9494"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M434.3,434.633a1.236,1.236,0,0,0-1.748,1.748l10.34,10.34a1.236,1.236,0,0,0,1.748-1.748Z"
            transform="translate(-358.917 -363.084)"
            fill="#ff9494"
          />
          <path
            id="Path_14"
            data-name="Path 14"
            d="M470.284,390.423l-5.17-1.411a1.236,1.236,0,1,0-.651,2.385l5.17,1.41a1.236,1.236,0,1,0,.651-2.385Z"
            transform="translate(-385.112 -325.168)"
            fill="#ff9494"
          />
          <path
            id="Path_15"
            data-name="Path 15"
            d="M388.645,466.545a1.236,1.236,0,1,0-2.385.651l1.411,5.17a1.236,1.236,0,0,0,2.385-.651Z"
            transform="translate(-320.583 -389.277)"
            fill="#ff9494"
          />
          <path
            id="Path_16"
            data-name="Path 16"
            d="M12.789,434.633l-10.34,10.34A1.236,1.236,0,1,0,4.2,446.722l10.34-10.34a1.236,1.236,0,0,0-1.748-1.748Z"
            transform="translate(-0.002 -363.084)"
            fill="#ff9494"
          />
          <path
            id="Path_17"
            data-name="Path 17"
            d="M8.165,389.012l-5.17,1.411a1.236,1.236,0,1,0,.651,2.385l5.17-1.41a1.236,1.236,0,1,0-.651-2.385Z"
            transform="translate(0 -325.167)"
            fill="#ff9494"
          />
          <path
            id="Path_18"
            data-name="Path 18"
            d="M105.2,465.678a1.236,1.236,0,0,0-1.518.867l-1.41,5.17a1.236,1.236,0,1,0,2.385.651l1.41-5.17A1.236,1.236,0,0,0,105.2,465.678Z"
            transform="translate(-83.579 -389.277)"
            fill="#ff9494"
          />
          <path
            id="Path_19"
            data-name="Path 19"
            d="M168.419,188.463a1.236,1.236,0,1,0,1.748,1.748l10.144-10.144a3.83,3.83,0,0,0,0-5.416l-3.188-3.188a3.835,3.835,0,0,0-5.416,0l-12.569,12.569-4.4-4.4a3.83,3.83,0,0,0-5.416,0l-3.442,3.442a3.83,3.83,0,0,0,0,5.416l8.818,8.819a5.923,5.923,0,0,0,8.367,0l3.04-3.04a1.236,1.236,0,1,0-1.748-1.748l-3.04,3.04a3.448,3.448,0,0,1-4.87,0l-8.818-8.819a1.357,1.357,0,0,1,0-1.919l3.442-3.442a1.357,1.357,0,0,1,1.92,0l5.272,5.272a1.236,1.236,0,0,0,1.748,0l13.444-13.443a1.359,1.359,0,0,1,1.92,0l3.188,3.188a1.357,1.357,0,0,1,0,1.919Z"
            transform="translate(-119.013 -142.463)"
            fill="#ff9494"
          />
        </g>
      </svg>
    ),

    digitalPrintingIcon: (
      <svg
        className="mb-3"
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 84 79"
      >
        <g id="print" transform="translate(0 0)">
          <path
            id="Path_20"
            data-name="Path 20"
            d="M177.194,262.518a5.335,5.335,0,1,0-5.335-5.335A5.341,5.341,0,0,0,177.194,262.518Zm0-8.182a2.847,2.847,0,1,1-2.847,2.847A2.851,2.851,0,0,1,177.194,254.336Zm0,0"
            transform="translate(-143.708 -210.259)"
            fill="#ff9494"
          />
          <path
            id="Path_21"
            data-name="Path 21"
            d="M431.471,102.3a3.639,3.639,0,1,0,3.639,3.639A3.643,3.643,0,0,0,431.471,102.3Zm0,4.789a1.151,1.151,0,1,1,1.151-1.151A1.152,1.152,0,0,1,431.471,107.094Zm0,0"
            transform="translate(-357.793 -85.407)"
            fill="#ff9494"
          />
          <path
            id="Path_22"
            data-name="Path 22"
            d="M431.471,153.988a3.639,3.639,0,1,0,3.639,3.639A3.643,3.643,0,0,0,431.471,153.988Zm0,4.789a1.151,1.151,0,1,1,1.151-1.151A1.152,1.152,0,0,1,431.471,158.777Zm0,0"
            transform="translate(-357.793 -128.554)"
            fill="#ff9494"
          />
          <path
            id="Path_23"
            data-name="Path 23"
            d="M77.543,11.672h-.089V10.415a6.222,6.222,0,0,0-6.193-6.238h-4.55A5.4,5.4,0,0,0,61.477,0H33.93a1.239,1.239,0,0,0,0,2.479H61.477a2.931,2.931,0,0,1,2.917,2.938V21.455H19.6V5.417a2.931,2.931,0,0,1,2.917-2.938h6.486a1.239,1.239,0,0,0,0-2.479H22.522a5.4,5.4,0,0,0-5.235,4.177h-4.55a6.222,6.222,0,0,0-6.193,6.238v1.257H6.456A6.486,6.486,0,0,0,0,18.174V55.3a6.487,6.487,0,0,0,6.456,6.5H17.144V73.4A5.587,5.587,0,0,0,22.705,79H61.293a5.587,5.587,0,0,0,5.561-5.6V61.807H77.543A6.487,6.487,0,0,0,84,55.3V18.174a6.486,6.486,0,0,0-6.456-6.5Zm-2.55-1.257v1.257H66.855V6.656h4.406a3.75,3.75,0,0,1,3.732,3.759Zm-65.988,0a3.75,3.75,0,0,1,3.732-3.759h4.406v5.016H9.006ZM64.394,57.576l-.815-.82a12.549,12.549,0,0,0-17.582,0l-5.52,5.559L37.49,59.3a11.007,11.007,0,0,0-7.858-3.277A11.147,11.147,0,0,0,21.773,59.3L19.6,61.489V37.979H64.394Zm-3.1,18.946H29.852l4.406-4.437a1.246,1.246,0,0,0,0-1.753,1.225,1.225,0,0,0-1.74,0l-6.147,6.19H22.705A3.114,3.114,0,0,1,19.6,73.4V64.994l3.909-3.937a8.721,8.721,0,0,1,6.119-2.551,8.568,8.568,0,0,1,6.117,2.551l2.987,3.01L35.97,66.854a1.245,1.245,0,0,0,0,1.752,1.224,1.224,0,0,0,1.74,0s10.262-10.329,10.383-10.44a10.018,10.018,0,0,1,13.745.341l2.555,2.573V73.4a3.115,3.115,0,0,1-3.1,3.121ZM81.538,55.3a4.015,4.015,0,0,1-4,4.024H66.855V37.979h7.957a1.239,1.239,0,0,0,0-2.479H9.187a1.239,1.239,0,0,0,0,2.479h7.957v21.35H6.455a4.015,4.015,0,0,1-4-4.024V18.174a4.014,4.014,0,0,1,4-4.024H17.144v8.544a1.235,1.235,0,0,0,1.23,1.239h47.25a1.235,1.235,0,0,0,1.23-1.239V14.151H77.543a4.014,4.014,0,0,1,4,4.024Zm0,0"
            transform="translate(0 0)"
            fill="#ff9494"
          />
        </g>
      </svg>
    ),

    onTimeDeliveryIcon: (
      <svg
        className="mb-3"
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 84 78"
      >
        <g id="express-delivery" transform="translate(0 -21.232)">
          <path
            id="Path_24"
            data-name="Path 24"
            d="M379.122,81.888a1.241,1.241,0,0,0,1.241-1.241V78.979a1.241,1.241,0,1,0-2.482,0v1.668A1.241,1.241,0,0,0,379.122,81.888Z"
            transform="translate(-315.901 -47.156)"
            fill="#ff9494"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M460.721,169.418a1.241,1.241,0,0,0,0,2.482h1.668a1.241,1.241,0,1,0,0-2.482Z"
            transform="translate(-384.171 -123.566)"
            fill="#ff9494"
          />
          <path
            id="Path_26"
            data-name="Path 26"
            d="M287.442,169.418a1.241,1.241,0,0,0,0,2.482h1.668a1.241,1.241,0,1,0,0-2.482Z"
            transform="translate(-239.267 -123.566)"
            fill="#ff9494"
          />
          <path
            id="Path_27"
            data-name="Path 27"
            d="M398.115,408.987a4,4,0,1,0,4,4A4,4,0,0,0,398.115,408.987Zm0,5.512a1.515,1.515,0,1,1,1.515-1.515A1.517,1.517,0,0,1,398.115,414.5Z"
            transform="translate(-329.625 -323.287)"
            fill="#ff9494"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M144.424,412.984a4,4,0,1,0,4-4A4,4,0,0,0,144.424,412.984Zm5.512,0a1.515,1.515,0,1,1-1.515-1.515A1.517,1.517,0,0,1,149.936,412.984Z"
            transform="translate(-120.751 -323.287)"
            fill="#ff9494"
          />
          <path
            id="Path_29"
            data-name="Path 29"
            d="M153.109,259.338a3.671,3.671,0,0,0-.029-5.285l-5.159-5.021a4.715,4.715,0,0,0-6.659.09l-.966.993a1.241,1.241,0,0,0,.024,1.755l4.973,4.84-4.973,4.84a1.241,1.241,0,0,0-.024,1.755l.966.993a4.708,4.708,0,0,0,6.659.09Zm-10.068,3.228-.1-.1,5-4.864a1.241,1.241,0,0,0,0-1.779l-5-4.864.1-.1a2.23,2.23,0,0,1,3.149-.043l5.159,5.021a1.183,1.183,0,0,1,.029,1.727l-5.187,5.049A2.227,2.227,0,0,1,143.041,262.566Z"
            transform="translate(-117.025 -188.802)"
            fill="#ff9494"
          />
          <path
            id="Path_30"
            data-name="Path 30"
            d="M377.881,125.423a1.241,1.241,0,0,0,1.241,1.241h4.221a1.241,1.241,0,0,0,0-2.482h-2.98v-7.729a1.241,1.241,0,1,0-2.482,0Z"
            transform="translate(-315.931 -78.357)"
            fill="#ff9494"
          />
          <path
            id="Path_31"
            data-name="Path 31"
            d="M121.862,100.3h21.37a1.241,1.241,0,1,0,0-2.482h-21.37a1.241,1.241,0,1,0,0,2.482Z"
            transform="translate(-100.898 -63.915)"
            fill="#ff9494"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M90.558,139.049H112.74a1.241,1.241,0,0,0,0-2.482H90.558a1.241,1.241,0,1,0,0,2.482Z"
            transform="translate(-74.715 -96.173)"
            fill="#ff9494"
          />
          <path
            id="Path_33"
            data-name="Path 33"
            d="M167.249,171.121a1.241,1.241,0,1,0,0,2.482h11.038a1.241,1.241,0,0,0,0-2.482Z"
            transform="translate(-138.817 -124.986)"
            fill="#ff9494"
          />
          <path
            id="Path_34"
            data-name="Path 34"
            d="M104.016,171.121a1.241,1.241,0,1,0,0,2.482h5.509a1.241,1.241,0,0,0,0-2.482Z"
            transform="translate(-85.929 -124.986)"
            fill="#ff9494"
          />
          <path
            id="Path_35"
            data-name="Path 35"
            d="M1.241,276.888H5.78a1.241,1.241,0,0,0,0-2.482H1.241a1.241,1.241,0,0,0,0,2.482Z"
            transform="translate(0 -211.111)"
            fill="#ff9494"
          />
          <path
            id="Path_36"
            data-name="Path 36"
            d="M4.551,355.47H1.241a1.241,1.241,0,1,0,0,2.482h3.31a1.241,1.241,0,1,0,0-2.482Z"
            transform="translate(0 -278.707)"
            fill="#ff9494"
          />
          <path
            id="Path_37"
            data-name="Path 37"
            d="M87.152,291.959H82.726a1.241,1.241,0,1,0,0,2.482h4.426a1.241,1.241,0,1,0,0-2.482Z"
            transform="translate(-68.127 -225.748)"
            fill="#ff9494"
          />
          <path
            id="Path_38"
            data-name="Path 38"
            d="M74.814,64.552a21.218,21.218,0,0,0,6.96-26.938,1.223,1.223,0,0,0-1.653-.55,1.253,1.253,0,0,0-.543,1.674,18.7,18.7,0,0,1-6.445,23.951l-7.164-7.937A4.388,4.388,0,0,0,62.718,53.3H45.966a18.661,18.661,0,0,1-1.052-6.206A18.449,18.449,0,0,1,63.226,28.552a18.232,18.232,0,0,1,13.713,6.255,1.22,1.22,0,0,0,1.737.107,1.257,1.257,0,0,0,.105-1.759,20.82,20.82,0,0,0-6.372-4.923v-4.22a2.767,2.767,0,0,0-2.746-2.781H56.79a2.767,2.767,0,0,0-2.746,2.781v4.219A21.187,21.187,0,0,0,43.375,53.3H12a3.015,3.015,0,0,0-2.985,2.786h-4.5a1.246,1.246,0,0,0,0,2.492H9V70.621H1.23a1.246,1.246,0,0,0,0,2.492H9v3.644a1.246,1.246,0,0,0,0,2.491V88.06a2.36,2.36,0,0,0,2.343,2.372h3.311V91.3H10.814a1.246,1.246,0,0,0,0,2.492h5.07a1.238,1.238,0,0,0,1.23-1.246V90.432h1.123a9.513,9.513,0,0,0,9.421,8.8,9.365,9.365,0,0,0,4.668-1.249,1.255,1.255,0,0,0,.461-1.7,1.223,1.223,0,0,0-1.678-.467,6.922,6.922,0,0,1-3.451.923A7.055,7.055,0,1,1,33.973,92.7a1.253,1.253,0,0,0,.581,1.661,1.224,1.224,0,0,0,1.64-.588,9.556,9.556,0,0,0,.883-3.342H59.2a9.443,9.443,0,0,0,18.841,0h2.533A3.449,3.449,0,0,0,84,86.966V76.456a4.468,4.468,0,0,0-1.15-3ZM56.5,24.013a.287.287,0,0,1,.285-.289H69.663a.287.287,0,0,1,.285.289V27.2a20.5,20.5,0,0,0-13.445,0V24.013Zm7.648,32.42L76.958,70.621H67.779a1.246,1.246,0,0,0,0,2.492H79.206l1.827,2.024c.745.825.432,1.721.506,2.671H80.59a1.246,1.246,0,0,0,0,2.492h.949v1.844H74.468a9.332,9.332,0,0,0-11.689,0H49.372V55.793h5.307V70.605a2.5,2.5,0,0,0,2.476,2.508h5.7a1.246,1.246,0,0,0,0-2.492h-5.7a.016.016,0,0,1-.015-.016V55.793h5.578A1.936,1.936,0,0,1,64.152,56.433ZM59.325,87.941H49.372V84.635H60.58A9.58,9.58,0,0,0,59.325,87.941ZM35.7,84.635H46.911v3.306H36.956A9.58,9.58,0,0,0,35.7,84.635Zm-24.239,0h8.154a9.58,9.58,0,0,0-1.256,3.306h-6.9Zm10.352-2.492H11.461v-2.9h5.332a1.246,1.246,0,0,0,0-2.492H11.461V73.113h5.332a1.246,1.246,0,0,0,0-2.492H11.461V56.336A.54.54,0,0,1,12,55.792H46.911V82.143H33.5a9.332,9.332,0,0,0-11.689,0Zm46.81,14.6a7.082,7.082,0,1,1,6.993-7.081A7.045,7.045,0,0,1,68.623,96.74Zm11.953-8.8H77.922a9.581,9.581,0,0,0-1.256-3.306h4.873v2.331A.969.969,0,0,1,80.577,87.941Z"
            transform="translate(0 0)"
            fill="#ff9494"
          />
        </g>
      </svg>
    ),

    customToolTipIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="512"
        viewBox="0 0 128 128"
        width="512"
      >
        <g>
          <path
            d="m56.463 14.337-49.563 92.307c-2.8 5.217 1.273 11.356 7.537 11.356h99.126c6.264 0 10.338-6.139 7.537-11.356l-49.563-92.307c-3.106-5.783-11.968-5.783-15.074 0z"
            fill="#ff0000"
          />
          <g fill="#fff">
            <path d="m64 31.726a5.418 5.418 0 0 0 -5.5 5.45l1.017 44.289a4.422 4.422 0 0 0 4.483 4.261 4.422 4.422 0 0 0 4.482-4.261l1.018-44.289a5.418 5.418 0 0 0 -5.5-5.45z" />
            <circle cx="64" cy="100.222" r="6" />
          </g>
        </g>
      </svg>
    ),

    // ==============CONTACT US SECTION=====================
    phoneIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 30 30"
      >
        <path
          id="Call"
          d="M26.25,20.569a3.418,3.418,0,0,0-2.51.66c-.723.421-2.1,1.536-2.885,1.251a17.9,17.9,0,0,1-9.469-9.24c-.289-.8.82-2.188,1.238-2.919a3.5,3.5,0,0,0,.655-2.528c-.189-.912-2.631-4.02-3.495-4.87A2.869,2.869,0,0,0,8.032,2C5.78,1.906,3.265,4.911,2.824,5.63c-1.105,1.533-1.1,3.572.019,6.045,2.693,6.643,12.878,16.667,19.546,19.461A8.059,8.059,0,0,0,25.755,32a4.378,4.378,0,0,0,2.627-.823c.571-.329,3.7-2.969,3.617-5.281a2.911,2.911,0,0,0-.912-1.75C30.243,23.274,27.155,20.759,26.25,20.569Z"
          transform="translate(-2 -2.001)"
          fill="#2ebced"
        />
      </svg>
    ),

    locationIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 25 30"
      >
        <path
          id="Location"
          d="M3.5,14.477a12.5,12.5,0,0,1,25,0,15.746,15.746,0,0,1-3.28,9.441,32.706,32.706,0,0,1-8.149,7.711,1.733,1.733,0,0,1-2.144,0A32.08,32.08,0,0,1,6.78,23.917,15.737,15.737,0,0,1,3.5,14.477Zm8.374.389a4.126,4.126,0,1,0,8.252,0,4.127,4.127,0,1,0-8.252,0Z"
          transform="translate(-3.5 -2)"
          fill="#2ebced"
          fillRule="evenodd"
        />
      </svg>
    ),

    // ==============HEADER SECTION=====================

    myprofileIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 68.2 85"
      >
        <path
          id="Profile"
          d="M59.835,24.222A22.235,22.235,0,1,1,37.6,2,22.152,22.152,0,0,1,59.835,24.222ZM37.6,86C19.382,86,4,83.039,4,71.615S19.479,57.33,37.6,57.33c18.222,0,33.6,2.961,33.6,14.385S55.721,86,37.6,86Z"
          transform="translate(-3.5 -1.5)"
          stroke="#000"
          strokeWidth="1"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),

    logoutIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 84 81.802"
      >
        <path
          id="Logout"
          d="M40.1,2.021A18.141,18.141,0,0,1,58.216,19.307l.02.854v3.816a3.068,3.068,0,0,1-6.107.416l-.028-.416V20.161A12.006,12.006,0,0,0,40.8,8.177l-.705-.02H20.157a12,12,0,0,0-11.98,11.3l-.02.705V65.684a12.005,12.005,0,0,0,11.3,11.984l.7.02h19.98A11.964,11.964,0,0,0,52.081,66.431l.02-.7V61.872a3.068,3.068,0,0,1,6.107-.416l.028.416v3.857A18.1,18.1,0,0,1,41.014,83.8l-.877.021H20.157A18.14,18.14,0,0,1,2.042,66.537l-.02-.854V20.161A18.14,18.14,0,0,1,19.3,2.041l.854-.02ZM85.076,40.706a3.068,3.068,0,0,1-.018,4.448L73.142,57.022a3.068,3.068,0,0,1-4.627-4l.3-.343,6.708-6.685H33.706a3.068,3.068,0,0,1-.416-6.107l.416-.028H75.528l-6.715-6.682a3.069,3.069,0,0,1-.306-3.993l.3-.345a3.068,3.068,0,0,1,3.993-.306l.345.3Z"
          transform="translate(-2.022 -2.021)"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),

    myOrdersIcon: (
      <svg
        className="me-2"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 76.6 85"
      >
        <path
          id="Document"
          d="M23.2,2H58.4C71.376,2,78.6,9.476,78.6,22.286V65.672C78.6,78.692,71.376,86,58.4,86H23.2C10.434,86,3,78.692,3,65.672V22.286C3,9.476,10.434,2,23.2,2Zm1.134,19.572V21.53H36.89a3.3,3.3,0,0,1,0,6.594H24.336a3.276,3.276,0,0,1,0-6.552Zm0,25.536H57.264a3.278,3.278,0,0,0,0-6.556H24.336a3.278,3.278,0,0,0,0,6.556Zm0,19.194H57.264a3.319,3.319,0,0,0,0-6.594H24.336a3.294,3.294,0,0,0-3.15,1.554,3.339,3.339,0,0,0,0,3.528A3.262,3.262,0,0,0,24.336,66.3Z"
          transform="translate(-2.5 -1.5)"
          stroke="#000"
          strokeWidth="1"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),

    profileStatusIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="512"
        viewBox="0 0 128 128"
        width="512"
      >
        <g>
          <path
            d="m56.463 14.337-49.563 92.307c-2.8 5.217 1.273 11.356 7.537 11.356h99.126c6.264 0 10.338-6.139 7.537-11.356l-49.563-92.307c-3.106-5.783-11.968-5.783-15.074 0z"
            fill="#ff0000"
          />
          <g fill="#fff">
            <path d="m64 31.726a5.418 5.418 0 0 0 -5.5 5.45l1.017 44.289a4.422 4.422 0 0 0 4.483 4.261 4.422 4.422 0 0 0 4.482-4.261l1.018-44.289a5.418 5.418 0 0 0 -5.5-5.45z" />
            <circle cx="64" cy="100.222" r="6" />
          </g>
        </g>
      </svg>
    ),

    navbarMenuIcon: (
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 72 72"
        id="emoji"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="color" />
        <g id="hair" />
        <g id="skin" />
        <g id="skin-shadow" />
        <g id="line">
          <line
            x1="16"
            x2="56"
            y1="26"
            y2="26"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            x1="16"
            x2="56"
            y1="36"
            y2="36"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <line
            x1="16"
            x2="56"
            y1="46"
            y2="46"
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </svg>
    ),

    invalidProfileIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="512"
        viewBox="0 0 128 128"
        width="512"
      >
        <g>
          <path
            d="m56.463 14.337-49.563 92.307c-2.8 5.217 1.273 11.356 7.537 11.356h99.126c6.264 0 10.338-6.139 7.537-11.356l-49.563-92.307c-3.106-5.783-11.968-5.783-15.074 0z"
            fill="#ff0000"
          />
          <g fill="#fff">
            <path d="m64 31.726a5.418 5.418 0 0 0 -5.5 5.45l1.017 44.289a4.422 4.422 0 0 0 4.483 4.261 4.422 4.422 0 0 0 4.482-4.261l1.018-44.289a5.418 5.418 0 0 0 -5.5-5.45z" />
            <circle cx="64" cy="100.222" r="6" />
          </g>
        </g>
      </svg>
    ),

    // ==================ADMIN HEADER SECTION=================

    notificationListIcon: (
      <svg
        id="Layer_1"
        enableBackground="new 0 0 512 512"
        height="512"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="m457.844 332.217-67.854 67.875c-1.43 1.432-3.049 1.731-4.162 1.731-1.98 0-3.758-.927-4.877-2.54-.1-.135-.201-.271-.301-.398l-28.561-35.938c-.98-1.231-1.42-2.77-1.238-4.333.176-1.563.955-2.962 2.188-3.942 1.328-1.059 2.719-1.28 3.65-1.28 1.811 0 3.5.813 4.621 2.224l19.41 24.421c1.408 1.785 3.529 2.88 5.797 3.011 2.289.136 4.502-.718 6.121-2.33l56.875-56.867c1.109-1.116 2.586-1.731 4.186-1.731 1.559 0 3.037.615 4.145 1.731 2.338 2.306 2.338 6.061 0 8.366zm11.324-19.677c-4.145-4.14-9.643-6.417-15.469-6.417-5.867 0-11.365 2.277-15.508 6.417l-50.533 50.523-13.818-17.4c-4.18-5.256-10.43-8.267-17.15-8.267-4.92 0-9.752 1.686-13.609 4.755-4.582 3.635-7.463 8.838-8.131 14.647-.658 5.81.98 11.529 4.619 16.104l28.422 35.765c4.109 5.74 10.762 9.158 17.838 9.158 5.84 0 11.332-2.281 15.473-6.417l67.867-67.878c8.532-8.543 8.532-22.448-.001-30.99zm-61.668 137.427c48.539 0 88.008-39.474 88.008-87.996 0-48.517-39.469-87.995-88.008-87.995-48.521 0-88.004 39.478-88.004 87.995 0 48.522 39.483 87.996 88.004 87.996zm-191.512-22.114 91.963-35.761c-2.893-9.535-4.451-19.649-4.451-30.12 0-54.651 42.379-99.59 96-103.689v-114.985l-183.512 71.354zm-199.496-284.555 50.039 19.46v58.348c0 3.373 1.619 6.581 4.336 8.583 2.713 1.994 6.262 2.585 9.482 1.583l24.602-7.652 27.44 23.38c1.957 1.67 4.428 2.54 6.918 2.54 1.51 0 3.031-.315 4.451-.972 3.758-1.736 6.191-5.531 6.191-9.675v-43.696l50.039 19.456v213.201l-183.498-71.355zm191.494-80.68 43.965 17.093-177.42 68.991-43.963-17.097zm-125.459 106.36v44.857l21.873-6.798c2.617-.817 5.469-.23 7.559 1.546l21.99 18.726v-38.338zm14.082-11.693 177.418-68.991 45.355 17.634c-59.152 22.997-118.293 45.994-177.432 68.987zm111.377 43.31-43.967-17.097c59.148-22.993 118.289-45.99 177.428-68.987l43.971 17.093zm207.516 57.688v-126.679c0-3.294-2.031-6.257-5.102-7.455l-199.511-77.569c-1.859-.726-3.928-.726-5.799 0l-199.5 77.57c-3.068 1.198-5.1 4.161-5.1 7.455v230.367c0 3.299 2.031 6.261 5.1 7.459l199.5 77.57c.939.361 1.922.545 2.896.545.994 0 1.975-.185 2.902-.545l102.873-40c16.816 34.858 52.508 58.963 93.738 58.963 57.359 0 104.01-46.65 104.01-103.993.001-54.65-42.382-99.59-96.007-103.688z"
          fill="#62a4fb"
          fillRule="evenodd"
        />
      </svg>
    ),

    bellIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 71.4 84"
      >
        <path
          id="notification"
          d="M39.352,2h-.3C24.9,2,11.927,12.267,10.669,25.86c-.084.972-.141,1.966-.178,3.036l-.052,2.5-.01,2.244.063-.256a16.17,16.17,0,0,1-3.9,7.647l-.282.363a17.136,17.136,0,0,0-2.8,8.585l0,1A17.1,17.1,0,0,0,7.392,62.154a20.472,20.472,0,0,0,12.963,6.4,174.648,174.648,0,0,0,37.692,0,20.155,20.155,0,0,0,12.8-6.248A17.119,17.119,0,0,0,74.9,51.82l0-1.694a16.856,16.856,0,0,0-2.82-8.711l-.259-.333-.633-.745a16.505,16.505,0,0,1-3.052-6.012l-.187-.786-.039-.824c-.012-.371-.017-.782-.019-1.3V28.595c-.01-1.081-.042-1.85-.116-2.716C66.472,12.26,53.494,2,39.352,2Zm-.3,5.86h.3c11.33,0,21.665,8.171,22.657,18.555.059.682.085,1.332.093,2.3l.011,3.8c.013.608.037,1.113.077,1.682l.054.389.273,1.158a22.391,22.391,0,0,0,4.255,8.387l.579.679-.064-.107a10.859,10.859,0,0,1,1.827,5.556l0,.687a11.142,11.142,0,0,1-2.575,7.447,14.354,14.354,0,0,1-9.059,4.328,169.139,169.139,0,0,1-36.539,0,14.638,14.638,0,0,1-9.232-4.474,11.157,11.157,0,0,1-2.413-7.206v-.919l.073-.8a11.217,11.217,0,0,1,1.317-3.944l.352-.582a22.051,22.051,0,0,0,5.125-10.222l.06-.6.027-3.861.067-1.959c.031-.618.07-1.205.119-1.774C17.394,16.032,27.719,7.86,39.052,7.86ZM11.035,44.8l-.188.21.207-.24ZM50.154,76.3a2.871,2.871,0,0,0-4.07.446,8.3,8.3,0,0,1-1.5,1.459,8.981,8.981,0,0,1-6.62,1.87,8.89,8.89,0,0,1-5.938-3.318,2.871,2.871,0,0,0-4.068-.466,2.955,2.955,0,0,0-.46,4.118A14.682,14.682,0,0,0,48.09,82.871a13.956,13.956,0,0,0,2.5-2.451A2.955,2.955,0,0,0,50.154,76.3Z"
          transform="translate(-3.5 -2)"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),

    transhIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 427 427.00131"
        xmlSpace="preserve"
      >
        <g>
          <path
            d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
            fill="#ffffff"
            data-original="#000000"
          />
          <path
            d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
            fill="#ffffff"
            data-original="#000000"
          />
          <path
            d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"
            fill="#ffffff"
            data-original="#000000"
          />
          <path
            d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"
            fill="#ffffff"
            data-original="#000000"
          />
        </g>
      </svg>
    ),

    // =========ORDER STATUS ICONS SECTION=================

    orderStatusIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.996"
        height="20.301"
        viewBox="0 0 94.996 20.301"
      >
        <path
          id="np_line_3037168_000000"
          d="M55.8,2.5H44.2a4.438,4.438,0,0,0-4.4,4.4V93.1a4.438,4.438,0,0,0,4.4,4.4H55.7a4.438,4.438,0,0,0,4.4-4.4l0-86.2a4.355,4.355,0,0,0-4.3-4.4Z"
          transform="translate(97.496 -39.801) rotate(90)"
        />
      </svg>
    ),

    // ============ USER ORDER DETAILS ICON SECTION ===========

    activityHistoryDownIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        viewBox="0 0 124 124"
        xmlSpace="preserve"
        fill="#2ebced"
        width="18px"
        height="18px"
        className="collapse-icon"
      >
        <g>
          <path d="M118,95.9H6c-5.3,0-8-6.4-4.2-10.2l56-56c2.3-2.3,6.1-2.3,8.4,0l56,56C126,89.5,123.3,95.9,118,95.9z" />
        </g>
      </svg>
    ),

    searchIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 84 84"
        fill="#FF9494"
      >
        <path
          id="Search"
          d="M42.368,2C20.074,2,2,19.674,2,41.477S20.074,80.954,42.368,80.954a40.769,40.769,0,0,0,25.206-8.639L80.7,85.112l.349.294a3.162,3.162,0,0,0,4.048-.3,2.993,2.993,0,0,0-.006-4.3L72.12,68.16A38.862,38.862,0,0,0,82.737,41.477C82.737,19.674,64.663,2,42.368,2Zm0,6.081c18.861,0,34.151,14.952,34.151,33.4s-15.29,33.4-34.151,33.4-34.15-14.952-34.15-33.4S23.508,8.081,42.368,8.081Z"
          transform="translate(-2 -2)"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),

    singleDownloadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Line"
        enableBackground="new 0 0 32 32"
        height="512"
        viewBox="0 0 32 32"
        width="512"
      >
        <path d="m30 24v4c0 1.103-.897 2-2 2h-24c-1.103 0-2-.897-2-2v-4c0-.552.448-1 1-1s1 .448 1 1v4h24v-4c0-.552.448-1 1-1s1 .448 1 1z" />
        <path d="m8.293 16.707c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l5.293 5.293v-17.586c0-.552.448-1 1-1s1 .448 1 1v17.586l5.293-5.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-7 7c-.396.397-1.031.384-1.415 0z" />
      </svg>
    ),

    invalidPriceIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="512"
        viewBox="0 0 128 128"
        width="512"
      >
        <g>
          <path
            d="m56.463 14.337-49.563 92.307c-2.8 5.217 1.273 11.356 7.537 11.356h99.126c6.264 0 10.338-6.139 7.537-11.356l-49.563-92.307c-3.106-5.783-11.968-5.783-15.074 0z"
            fill="#ff0000"
          />
          <g fill="#fff">
            <path d="m64 31.726a5.418 5.418 0 0 0 -5.5 5.45l1.017 44.289a4.422 4.422 0 0 0 4.483 4.261 4.422 4.422 0 0 0 4.482-4.261l1.018-44.289a5.418 5.418 0 0 0 -5.5-5.45z" />
            <circle cx="64" cy="100.222" r="6" />
          </g>
        </g>
      </svg>
    ),

    moreIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 77 77"
      >
        <path
          id="More_Circle"
          data-name="More Circle"
          d="M40.5,2A38.5,38.5,0,1,0,79,40.5,38.5,38.5,0,0,0,40.5,2Zm0,5.775A32.725,32.725,0,1,1,7.775,40.5,32.728,32.728,0,0,1,40.5,7.775ZM18.642,40.5a4.612,4.612,0,1,0,4.612-4.612A4.615,4.615,0,0,0,18.642,40.5ZM40.5,45.109A4.61,4.61,0,1,1,45.112,40.5,4.615,4.615,0,0,1,40.5,45.109ZM53.132,40.5a4.612,4.612,0,1,0,4.612-4.612A4.615,4.615,0,0,0,53.132,40.5Z"
          transform="translate(-2 -2)"
          fillRule="evenodd"
          opacity="1"
          fill="#FF9494"
        />
      </svg>
    ),
  };

  return svgIcons[name] || null;
};

export default memo(SVGFiles);
